var _g, _path, _g2, _path2, _path3, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProblemSolutionMapping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 220,
    viewBox: "0 0 640 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#FFFFFF",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140 42C132 42 125 49 125 57V80C113 85 105 97 105 111C105 130 121 146 140 146C159 146 175 130 175 111C175 97 167 85 155 80V57C155 49 148 42 140 42Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 146V161"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 161,
    width: 30,
    height: 28,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130 189H150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 111H105"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175 111H189"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 24V10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 34L101 22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172 34L179 22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 188L101 200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172 188L179 200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118 111H140V89"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140 42C156 42 169 55 169 71H140V42Z",
    fill: "#EF4444"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#FFFFFF",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M502 42C494 42 487 49 487 57V80C475 85 467 97 467 111C467 130 483 146 502 146C521 146 537 130 537 111C537 97 529 85 517 80V57C517 49 510 42 502 42Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502 146V161"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487,
    y: 161,
    width: 30,
    height: 28,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492 189H512"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453 111H467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537 111H551"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502 24V10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470 34L463 22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534 34L541 22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480 111H502V89"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M188 128C220 128 220 128 252 128",
    stroke: "#FFFFFF",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeDasharray: "4 12"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M388 146C420 146 420 146 452 146",
    stroke: "#FFFFFF",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeDasharray: "4 12"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    stroke: "#FFFFFF",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 112,
    r: 28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321 58V74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321 150V166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274 112H290"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352 112H368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287 78L299 90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343 134L355 146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355 78L343 90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299 134L287 146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290 76L300 66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342 158L352 148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342 66L352 76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290 148L300 158"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 384,
    cy: 48,
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 24V14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 82V72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 48H370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398 48H408"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368 32L374 38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394 58L400 64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 32L394 38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374 58L368 64"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProblemSolutionMapping);
export default __webpack_public_path__ + "static/media/problemSolutionMapping.45fc1703e6803c6e7228e78251d5f464.svg";
export { ForwardRef as ReactComponent };